class Empresas {
    static get $inject() {
        return ['gql']
    }

    constructor(gql) {
        this.gql = gql
    }

    getEmpresa(empresaId) {
        const query = gql`
            query GetEmpresa($empresaId: Int!) {
                empresa(id: $empresaId) {
                    id
                    razaoSocial
                    raizCnpj
                    filiais {
                        id
                        cnpj
                        razaoSocial
                        pisCofinsVigente {
                            id
                            simplesNacional
                            geraCredito
                            regimeTributario {
                                id
                                tipo
                            }
                        }
                        cidade {
                            id
                            nome
                            estado {
                                id
                                sigla
                            }
                        }
                    }
                }
            }
        `

        return this.gql.query(query, { empresaId: parseInt(empresaId) })
            .then(({ empresa }) => {
                return {
                    ...empresa,
                    filiais: empresa.filiais.map(filial => this._parseFilial(filial))
                }
            })
    }

    listFiliais(empresaId) {
        const query = gql`
            query Empresas($empresaId: Int!) {
                usuarioAtual {
                    id
                    permissoes(filter: {empresaId: $empresaId}) {
                        id
                        filiais {
                            id
                            cnpj
                            razaoSocial
                            ferramentasDisponiveis
                            icms {
                                id
                                simplesNacional
                            }
                            pisCofinsVigente {
                                id
                                simplesNacional
                                geraCredito
                                regimeTributario {
                                    id
                                    tipo
                                }
                            }
                            cidade {
                                id
                                nome
                                estado {
                                    id
                                    sigla
                                }
                            }
                        }
                    }
                }
            }
        `

        return this.gql.query(query, { empresaId })
            .then(({ usuarioAtual: { permissoes: [{ filiais }] } }) => {
                return filiais.map(filial => this._parseFilial(filial))
            })
    }

    _parseFilial(filial) {
        return {
            ...filial,
            id: filial.id,
            cidade: filial.cidade.nome,
            estado: filial.cidade.estado.sigla
        }
    }
}

angular.module("eficienciaFiscalModule").service("Empresas", Empresas)
